import { ability, type AppAbility } from '@/plugins/casl'

export function useAppAbility(): {
  ability: AppAbility
  can: (action: string, subject: string) => boolean
  cannot: (action: string, subject: string) => boolean
} {
  return {
    ability,
    can: (action, subject) => ability.can(action, subject),
    cannot: (action, subject) => ability.cannot(action, subject)
  }
}
